export const adjustmentTypes = {
  ADD_EMPLOYEE_IN_ADJUSTMENT: 'ADD_EMPLOYEE_IN_ADJUSTMENT',
  REMOVE_EMPLOYEE_IN_ADJUSTMENT: 'REMOVE_EMPLOYEE_IN_ADJUSTMENT',
  RESET_ENTIRE_STATE: 'RESET_ENTIRE_STATE',
  CHANGE_EMPLOYEE_VALUE: 'CHANGE_EMPLOYEE_VALUE',
  DELETE_ADJUSTMENT: 'DELETE_ADJUSTMENT',
  ADDSAMEDATE: 'ADDSAMEDATE'
};
